import React, { FC, useEffect, useMemo } from 'react';
import styles from './index.module.scss';
import { FooterView, Footer } from 'src/common';
import { TenderNav, TenderHeader, Header, TendersNav } from 'src/shared';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { Paths } from '../paths';
import TenderPage from '../TenderPage';
import BidPage from '../BidPage';
import TenderFreePage from '../TenderFreePage';
import { TenderNavProvider } from 'src/models/procurements/TenderNav/providers';
import { isPaidUser, useApp } from 'src/models/auth';
import { useTenderId } from 'src/models/procurements/TenderFree/hooks';
import { isString, useQueryParams } from 'src/helpers';

export const TenderRouts: FC = () => {
  const navigate = useNavigate();
  const { user } = useApp();
  const isPaid = useMemo(() => isPaidUser(user), [user]);
  const { id } = useTenderId();
  const qp = useQueryParams();

  useEffect(() => {
    if (id) {
      navigate(`${Paths.TENDER_PAGE.replace(':id', id)}`, { replace: true });
    }
  }, [id, navigate]);

  return isPaid ? (
    <TenderNavProvider>
      <div className={styles.layout}>
        <Header />
        <div className={styles.page} id={'tender'}>
          <TendersNav isNarrow />
          <TenderNav />
          <main className={styles.container}>
            <TenderHeader />
            <div className={styles.content}>
              <Routes>
                <Route path={Paths.TENDER_PAGE} element={<TenderPage />} />
                <Route path={Paths.BIDDING_PAGE} element={<BidPage />} />
              </Routes>
            </div>
            <Footer view={FooterView.logo} />
          </main>
        </div>
      </div>
    </TenderNavProvider>
  ) : isString(qp['auth']) ? (
    <TenderFreePage />
  ) : (
    <Navigate to={Paths.ROOT} />
  );
};

export default TenderRouts;
